import React from 'react';
import {
  BlockerErrorBoundary as BlockingErrorBoundary,
  ErrorBoundary,
} from '@edreamsodigeo/frontend-core';

export const withBlockingErrorBoundary = (Component, { name }) => {
  return (props) => (
    <BlockingErrorBoundary name={name}>
      <Component {...props} />
    </BlockingErrorBoundary>
  );
};

export const withProviderErrorBoundary = (Provider, { name }) => {
  return (props) => (
    <ErrorBoundary name={name} fallback={props.children}>
      <Provider {...props} />
    </ErrorBoundary>
  );
};
